import { MtProjectGroup } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setProjectGroupList = (groupList: types.ProjectGroupList) => ({
    type: inferLiteral(types.PROJECT_GROUP_LIST),
    groupList,
})
export const setProjectGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.PROJECT_GROUP_IDS),
    groupIds,
})
export const setProjectGroupEdit = (group: MtProjectGroup) => ({
    type: inferLiteral(types.PROJECT_GROUP_EDIT),
    group,
})
export const setProjectGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.PROJECT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setProjectGroupFilters = (filters: types.ProjectGroupFilters) => ({
    type: inferLiteral(types.PROJECT_GROUP_FILTERS),
    filters,
})
export const setProjectGroupReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_GROUP_RELOAD_LIST),
    value,
})
export const setProjectGroupReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_GROUP_RELOAD_EDIT),
    value,
})
